import { Omit } from '@40seas/entities/common';
import { BaseEntityFieldsArray } from '@40seas/models';
import { ComplyAdvantage } from './comply-advantage.entity';

export class CreateComplyAdvantageDto extends Omit(ComplyAdvantage, BaseEntityFieldsArray) {}
